import {
  ApplicationConfig,
  inject,
  provideExperimentalZonelessChangeDetection,
} from '@angular/core';
import {
  provideRouter,
  withComponentInputBinding,
  withRouterConfig,
  withViewTransitions,
} from '@angular/router';
import { appRoutes } from './app.routes';
import {
  provideHttpClient,
  withInterceptors,
  withNoXsrfProtection,
} from '@angular/common/http';
import { provideOAuthClient } from 'angular-oauth2-oidc';
import { environment } from '../environments/environment';
import { provideAppImageLoader } from '@pool-league/frontend-shared-util-app-config';
import { APP_IMAGE_LOADER_CONFIG } from './image-loader/app-image-loader';
import { provideStore } from '@ngrx/store';
import { authInterceptor } from '@pool-league/frontend-shared-util-auth';
import { VIEW_TRANSITION } from '@pool-league/frontend-shared-util-view-transitions';
import { WebPlayerDetailsResolver } from '@pool-league/frontend-web-feature-common';
import {
  PLAYER_COMPONENT_CONFIG,
  PlayerComponentConfig,
} from '@pool-league/frontend-shared-ui-player';

export const appConfig: ApplicationConfig = {
  providers: [
    provideExperimentalZonelessChangeDetection(),
    provideRouter(
      appRoutes,
      withRouterConfig({
        paramsInheritanceStrategy: 'always',
      }),
      withComponentInputBinding(),
      withViewTransitions({
        onViewTransitionCreated: (info) => {
          const vt = inject(VIEW_TRANSITION);
          vt.set(info);
          info.transition.finished.finally(() => {
            vt.set(undefined);
          });
        },
      }),
    ),
    provideHttpClient(
      withNoXsrfProtection(),
      withInterceptors([authInterceptor()]),
    ),
    provideStore(),
    provideOAuthClient(),
    provideAppImageLoader(APP_IMAGE_LOADER_CONFIG),
    ...environment.providers,
    {
      provide: PLAYER_COMPONENT_CONFIG,
      useFactory: (
        detailsResolver: WebPlayerDetailsResolver,
      ): PlayerComponentConfig => ({
        detailsResolver,
        profileLink: (bbUserName) => ['/players', bbUserName],
      }),
      deps: [WebPlayerDetailsResolver],
    },
  ],
};
